import { reactive, computed } from "vue";
import { useStore } from "vuex";
import { getMe } from "@/entities/session";
import { updateUserMeContact } from "@/entities/user";

const PATCH_FIELDS = ["email", "phone"];

function clone(v) {
  return JSON.parse(JSON.stringify(v ?? {}));
}

function pickPatchFields(data) {
  const out = {};
  for (const k of PATCH_FIELDS) {
    if (data[k] !== undefined) out[k] = data[k];
  }
  return out;
}

export function useUserProfileDrawerData() {
  const store = useStore();

  const state = reactive({
    loading: false,
    saving: false,
    error: null,
    data: {},
    original: {},
    editMode: false,
  });

  const canEdit = computed(() => true);

  const dirty = computed(
    () => JSON.stringify(state.data) !== JSON.stringify(state.original)
  );

  async function load() {
    state.loading = true;
    state.error = null;
    state.editMode = false;
    state.data = {};
    state.original = {};

    try {
      const res = await getMe();
      if (res === undefined) {
        state.error = new Error("Failed to load user");
        return;
      }
      const payload = res?.payload ?? res ?? {};
      state.data = clone(payload);
      state.original = clone(payload);
    } catch (e) {
      console.error(e);
      state.error = e;
    } finally {
      state.loading = false;
    }
  }

  function update(key, value) {
    state.data[key] = value;
  }

  function cancel() {
    state.data = clone(state.original);
    state.editMode = false;
  }

  async function save() {
    if (state.saving) return;
    state.saving = true;
    try {
      const payload = pickPatchFields(state.data);
      const res = await updateUserMeContact(payload);
      const updated = res?.payload ?? res ?? null;
      if (updated && typeof updated === "object") {
        state.data = clone({ ...state.data, ...updated });
        state.original = clone(state.data);
      } else {
        state.original = clone(state.data);
      }
      const current = store.getters.get_self_user || {};
      store.commit("SET_SELF_USER", { ...current, ...payload });
      state.editMode = false;
    } finally {
      state.saving = false;
    }
  }

  return {
    state,
    dirty,
    canEdit,
    load,
    update,
    cancel,
    save,
  };
}
